// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3SD3W","label":"Radio_label__3dBl2","checkMark":"Radio_checkMark__2H28P","disabled":"Radio_disabled__3fsQU"};